import * as React from "react";
import Waves from "elements/Background/Waves";
import Icon from "semantic-ui-react/dist/commonjs/elements/Icon";
import ProductsList, {ProductKeys} from "containers/Pricing/products";
import PricingChallengesSection from "containers/Pricing/sections/PricingChallengesSection";

import {PricingTexts} from "i18n/containers/Pricing";
import {PricingTranslations} from "i18n/containers/Pricing/typing";
import PricingTalentsSections from "containers/Pricing/sections/PricingTalentsSection";
import PricingElearningsSection from "containers/Pricing/sections/PricingElearningsSection";
import {SemanticICONS} from "semantic-ui-react/dist/commonjs/generic";
import {useRouter} from "next/router";
import {useLocales} from "@libs";

const isAValidProduct = (product: string): boolean => {
    return product === ProductKeys.Elearnings || product === ProductKeys.Talents || product === ProductKeys.Challenges;
};

const Pricing = () => {
    const router = useRouter();
    const {currentShortLocale} = useLocales();
    const pricingTranslations: PricingTranslations = {
        ...PricingTexts[currentShortLocale],
    };
    const {product} = router.query;
    const initActiveProduct = product && isAValidProduct(String(product)) ? product : ProductKeys.Elearnings;
    const [currentActiveProduct, setCurrentActiveProduct] = React.useState(initActiveProduct);

    const handleOnChangeCurrentActiveProduct = (productKey: ProductKeys) => () => {
        setCurrentActiveProduct(productKey);
    };

    const getListItemClassNames = (isSelected: boolean) => {
        let className = "margin-1-x padding-2-x padding-1-y";

        if (isSelected) {
            className += " Pricing--SelectedProduct";
        }

        return className;
    };

    const getCurrentActiveSection = () => {
        switch (currentActiveProduct) {
            case ProductKeys.Elearnings:
                return <PricingElearningsSection/>;
            case ProductKeys.Talents:
                return <PricingTalentsSections/>;
            case ProductKeys.Challenges:
                return <PricingChallengesSection/>;
            default:
                return <></>;
        }
    };

    return (
        <main className={`Pricing Pricing--${currentActiveProduct} padding-4-top padding-6-bottom`}>
            <ul className={"Pricing--SelectProduct"}>
                {ProductsList.map((product) => (
                    <li
                        key={product.key}
                        className={getListItemClassNames(product.key === currentActiveProduct)}
                        onClick={handleOnChangeCurrentActiveProduct(product.key)}
                    >
                        <Icon
                            name={product.icon as SemanticICONS}
                            className={"margin-0_5-right"}
                            size={"large"}
                        />
                        <p>{pricingTranslations.getTranslationByProductKey(product.key)}</p>
                    </li>
                ))}
            </ul>

            {getCurrentActiveSection()}

            <Waves/>
        </main>
    );
};

export default Pricing;
